<template>
  <div id="app" class="outer-container">
    <router-view></router-view>
    <Footer v-show="$route.meta.show"></Footer>
  </div>
</template>

<script>
import Footer from './components/Other/Footer'

export default {
  name: 'App',
  components: {
    Footer
  },
  watch: {
    '$route.query.lang': {
      immediate: true,
      handler (locale) {
        if (locale === 'en' || locale === 'zh') {
          this.$i18n.locale = locale
        }
      }
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue